import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import {makeStyles} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const useStyles = makeStyles((theme) => ({
    openButton: {
        borderRadius: '4px',
        backgroundColor: '#bedc13',
        height: '48px',
        width: '250px',
        '&:hover': {
            backgroundColor: '#bedc13',
        },
        marginBottom: '10px',
    }
}));
type Props = {
    order: any,
    open: boolean,
    message:string,
};
const ServerOpendoorButton = ({ open = false, order={},message: string }: Props) => {
    const my_order_id=order.orderId;
    console.log(order);
    const  ServerOpendoor_handleEvent = () => {
        alert("please go  near machine \n click ok ");
        console.log("I was clicked");
        let promiseObj=getAssessment();
        let data=promiseObj.then(function(response){ return response.json(); }).then(function(data) {
            const items = data;
            console.log(items)
        })
        alert(data);
    };

    function getAssessment() {
        const data = {"imei":"TM12202102","mobile":"9632828337"} //some request data here
        const imei='TM12202102'
        const url = 'https://neuustore.com/tm/process-order/getorder/TM12202102'   // API URL
        const promiseObj = new Promise(function(resolve, reject) {
            const xhr = new XMLHttpRequest()
            xhr.open('POST', url, true)
            xhr.setRequestHeader('Content-Type', 'application/json')
            xhr.send(JSON.stringify(data))
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        console.log('Request processed successfully')
                        const resp = xhr.responseText
                        const respJson = JSON.stringify(resp)
                        alert(respJson)
                    }
                }
            }
        })
    return promiseObj
}
    return (
        <Button type="button" onClick={ServerOpendoor_handleEvent} className={useStyles.openButton} >
            Open Door
        </Button>
    );


};


export default ServerOpendoorButton;